import { dateWithoutOffsert } from '../License/mappers/mapResponseToLicense'

export default function(api: GlobalFetch) {
  return async function(startDate, finishDate) {
    const response = await api.fetch(
      `/api/v2/airbnb/priceslist/start/${startDate}/end/${finishDate}`,
    )
    return await handleResponse(response)
  }
}

export async function handleResponse(response) {
  const json: IData = await response.json()
  return json.items ? json.items.map(mapResponseToPriceGrid) : []
}

const mapResponseToPriceGrid = (item) => ({
  ...item,
  prices: item.prices
    ? item.prices.map((p) => ({
        ...p,
        to: dateWithoutOffsert(new Date(p.date)),
        from: dateWithoutOffsert(new Date(p.date)),
      }))
    : [],
})

interface IData {
  messages: string[]
  items: IAirbnbPriceGridData[]
}

export interface IAirbnbPriceGridData {
  id_room: string
  prices: IAirbnbPriceData[]
  airbnb_id_listing: string
}

export interface IAirbnbPriceData {
  availability: string
  availability_sub_type: string | null
  availability_type: string
  closed_to_arrival: boolean
  closed_to_departure: boolean
  daily_price: number
  date: string
  max_nights: number
  min_nights: number
  notes: string | null
}
